import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class TeamsIndexRoute extends Route {
	@service('model-manager/teams') declare mmTeamsService: Service.ModelManager.Teams;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		document.body.id = 'page-teams';

		const promises: Promise<unknown>[] = [];
		promises.push(this.navigationService.initialRequestsPromise);
		promises.push(this.mmTeamsService.requestTeams());

		return Promise.all(promises);
	}

	override afterModel(_model: unknown, transition: PublicTransition): void {
		if (!this.mmTeamsService.userTeamModels.length) {
			const fallbackRoute = transition.from?.name || 'index';

			this.navigationService.replaceRoute(fallbackRoute).then(() => {
				this.mmTeamsService.createAndOpenEditTeamPopup();
			});
		}
	}
}
